export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9103.e87fe898.jpg";